export default "__VITE_ASSET__Cw3bkDcR__"